export const fmtCents = (c) =>
  `$${(Number(c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const TXN_LABELS = {
  portfolio_profit: "Portfolio Profit",
  portfolio_loss: "Portfolio Loss",
  circuit_breaker_refund: "Circuit Breaker Refund",
  referral_commission: "Referral Commission",
  rank_reward: "Rank Reward Bonus",
  quantum_flex: "Quantum Flex",
  topup: "Top-Up",
  withdrawal: "Withdrawal",
  wallet_transfer: "Wallet Transfer",
  membership: "Membership",
  portfolio_purchase: "Portfolio Purchase",
  refund: "Refund",
  deposit: "Deposit",
  other: "Other",
};

export const WALLET_LABELS = { main: "Main Wallet", staking: "Staking Wallet", referral: "Referral Wallet" };
